import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstanceg4mecbw0mfx8 as Companion_getInstance } from '../ExecutionContext.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { trim11nh7r46at6sx as trim } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HttpMethod_Get_instance;
var HttpMethod_Post_instance;
var HttpMethod_entriesInitialized;
function HttpMethod_initEntries() {
  if (HttpMethod_entriesInitialized)
    return Unit_instance;
  HttpMethod_entriesInitialized = true;
  HttpMethod_Get_instance = new (HttpMethod())('Get', 0);
  HttpMethod_Post_instance = new (HttpMethod())('Post', 1);
}
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var HttpHeaderClass;
function HttpHeader() {
  if (HttpHeaderClass === VOID) {
    class $ {
      constructor(name, value) {
        this.t48_1 = name;
        this.u48_1 = value;
      }
      toString() {
        return 'HttpHeader(name=' + this.t48_1 + ', value=' + this.u48_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.t48_1);
        result = imul(result, 31) + getStringHashCode(this.u48_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpHeader()))
          return false;
        if (!(this.t48_1 === other.t48_1))
          return false;
        if (!(this.u48_1 === other.u48_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpHeader');
    HttpHeaderClass = $;
  }
  return HttpHeaderClass;
}
function _get_hasBody__xziwnf($this) {
  return !($this.w48_1 == null) || !($this.x48_1 == null);
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(statusCode) {
        this.v48_1 = statusCode;
        this.w48_1 = null;
        this.x48_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.y48_1 = ArrayList().p2();
        this.z48_1 = Companion_getInstance().a40_1;
      }
      a49(bodySource) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.check' call
        if (!!_get_hasBody__xziwnf(this)) {
          var message = 'body() can only be called once';
          throw IllegalStateException().o(toString(message));
        }
        this.w48_1 = bodySource;
        return this;
      }
      j48(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.y48_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.i2(element);
        return this;
      }
      l48(headers) {
        // Inline function 'kotlin.apply' call
        this.y48_1.u2(headers);
        return this;
      }
      i37() {
        return new (HttpResponse())(this.v48_1, this.y48_1, this.w48_1, this.x48_1, this.z48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var HttpResponseClass;
function HttpResponse() {
  if (HttpResponseClass === VOID) {
    class $ {
      constructor(statusCode, headers, bodySource, bodyString, executionContext) {
        this.b49_1 = statusCode;
        this.c49_1 = headers;
        this.d49_1 = bodySource;
        this.e49_1 = bodyString;
        this.f49_1 = executionContext;
      }
      g49() {
        var tmp0_elvis_lhs = this.d49_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.e49_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = (new (Buffer())()).s3w(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HttpResponse');
    HttpResponseClass = $;
  }
  return HttpResponseClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(method, url) {
        this.e48_1 = method;
        this.f48_1 = url;
        this.g48_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.h48_1 = ArrayList().p2();
        this.i48_1 = Companion_getInstance().a40_1;
      }
      k48(body) {
        // Inline function 'kotlin.apply' call
        this.g48_1 = body;
        return this;
      }
      j48(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.h48_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.i2(element);
        return this;
      }
      l48(headers) {
        // Inline function 'kotlin.apply' call
        this.h48_1.u2(headers);
        return this;
      }
      t41(executionContext) {
        // Inline function 'kotlin.apply' call
        this.i48_1 = this.i48_1.u41(executionContext);
        return this;
      }
      i37() {
        return new (HttpRequest())(this.e48_1, this.f48_1, this.h48_1, this.g48_1, this.i48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {
      constructor(method, url, headers, body, executionContext) {
        this.h49_1 = method;
        this.i49_1 = url;
        this.j49_1 = headers;
        this.k49_1 = body;
        this.l49_1 = executionContext;
      }
      m49(method, url) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Builder_0())(method, url);
        if (!(this.k49_1 == null)) {
          this_0.k48(this.k49_1);
        }
        this_0.l48(this.j49_1);
        this_0.t41(this.l49_1);
        return this_0;
      }
      n49(method, url, $super) {
        method = method === VOID ? this.h49_1 : method;
        url = url === VOID ? this.i49_1 : url;
        return $super === VOID ? this.m49(method, url) : $super.m49.call(this, method, url);
      }
    }
    initMetadataForClass($, 'HttpRequest');
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
function get(_this__u8e3s4, name) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s = _this__u8e3s4.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = element.t48_1.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      if (tmp === name.toLowerCase()) {
        if (found) {
          tmp$ret$0 = null;
          break $l$block_0;
        }
        single = element;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    tmp$ret$0 = single;
  }
  var tmp0_safe_receiver = tmp$ret$0;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u48_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp_0 = toString(trim(isCharSequence(tmp1_safe_receiver) ? tmp1_safe_receiver : THROW_CCE()));
  }
  return tmp_0;
}
function HttpMethod_Get_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_Get_instance;
}
function HttpMethod_Post_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_Post_instance;
}
//region block: exports
export {
  HttpHeader as HttpHeader1d7ldebjomr00,
  Builder_0 as Builder2ocxamygt14i4,
  Builder as Builder1mo34du82b3c6,
  get as get3c0ofj2dgi8ma,
  HttpMethod_Get_getInstance as HttpMethod_Get_getInstance32yh63ksulkub,
  HttpMethod_Post_getInstance as HttpMethod_Post_getInstanceu6nxq43savnq,
};
//endregion

//# sourceMappingURL=Http.mjs.map
